import { render, staticRenderFns } from "./proto_huawei.vue?vue&type=template&id=07c2915e&scoped=true&"
import script from "./proto_huawei.vue?vue&type=script&lang=js&"
export * from "./proto_huawei.vue?vue&type=script&lang=js&"
import style0 from "./proto_huawei.vue?vue&type=style&index=0&id=07c2915e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2915e",
  null
  
)

export default component.exports